import { MAX_QUERY_LENGTH } from "@boxem/core-query-language";
import { Static, Type } from "@fastify/type-provider-typebox";

// export const KeepaAmazonAvailability = Type.Enum({
//   noAmazonOffer: -1,
//   amazonInStockAndShippable: 0,
//   amazonPreorder: 1, // (not in stock but pre-orders pending)
//   amazonUnknown: 2,
//   amazonBackorder: 3, // not in stock but will be soon
//   amazonShippingDelay: 4, //
// });

export const BoxemProductFinderResponseProduct = Type.Object({
  asin: Type.String(),
  name: Type.String(),
  description: Type.Optional(Type.String()),
  ean: Type.Optional(Type.String()),
  upc: Type.Optional(Type.String()),
  brand: Type.Optional(Type.String()),
  brandStoreUrl: Type.Optional(Type.String()),
  manufacturer: Type.Optional(Type.String()),
  image0: Type.Optional(Type.String()),
  frequentlyBoughtTogether: Type.Optional(Type.Array(Type.String())), // array of asins
  // availabilityAmazon?
  // variations?


  // these are optional and will be filled-in if the query for these products included that data:
  offerCount: Type.Optional(Type.Integer()),
  salesRanks: Type.Optional(Type.Array(Type.Object({
    categoryId: Type.String(),
    categoryName: Type.String(),
    rank: Type.Integer(),
    highestRank: Type.Integer(),
    lowestRank: Type.Integer(),
    productCount: Type.Integer(),
  }))),
  buyBoxPrice: Type.Optional(Type.Integer()),
  buyBoxIsPrimeExclusive: Type.Optional(Type.Boolean()), 
  buyBoxIsPrimeEligible: Type.Optional(Type.Boolean()), 
  buyBoxIsPrimePantry: Type.Optional(Type.Boolean()), 
  buyBoxEligibleOfferCounts: Type.Optional(Type.Array(Type.Integer())),
});
export type BoxemProductFinderResponseProduct = Static<typeof BoxemProductFinderResponseProduct>;

export const BoxemProductFinderBrand = Type.Object({
  name: Type.String(),
  productCount: Type.Integer(),
  cardbearUrl: Type.Optional(Type.String()),
  cashbackMonitorUrl: Type.Optional(Type.String()),
  couponBirdsUrl: Type.Optional(Type.String()),
  topCashbackUrl: Type.Optional(Type.String()),
  giftCardWikiUrl: Type.Optional(Type.String()),
  capitalOneUrl: Type.Optional(Type.String()),
  slickDealsUrl: Type.Optional(Type.String()),
  couponFollowUrl: Type.Optional(Type.String()),
});
export type BoxemProductFinderBrand = Static<typeof BoxemProductFinderBrand>;

export const BoxemProductFinderResponse = Type.Object({
  totalResults: Type.Integer(),
  products: Type.Array(BoxemProductFinderResponseProduct),
  brands: Type.Array(BoxemProductFinderBrand),
});
export type BoxemProductFinderResponse = Static<typeof BoxemProductFinderResponse>;

export const BoxemProductFinderQuery = Type.String({ minLength: 1, maxLength: MAX_QUERY_LENGTH });
export type BoxemProductFinderQuery = Static<typeof BoxemProductFinderQuery>;

export const BoxemProductFinderCacheResponse = Type.Object({
  isCached: Type.Optional(Type.Boolean()),
});
export type BoxemProductFinderCacheResponse = Static<typeof BoxemProductFinderCacheResponse>;
